// Süper admin › Katalog › Excel'den İçe Aktar penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.catalogImport';

export const catalogImportGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, "Excel'den katalog içe aktarma nasıl yapılır?"),
  intro: t(`${G}.intro`, 'Bir Excel dosyasındaki ürünleri ortak kataloğa toplu olarak eklersiniz. İşlem üç adımdır: sütunları eşleştirin, önizlemeyi kontrol edin, sonucu görün. Yanlış eşleştirme kataloğa hatalı bilgi yazar; önizlemeyi mutlaka inceleyin. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, "Excel'den İçe Aktar"),
    tabs: t(`${G}.regions.tabs`, 'Adımlar'),
    body: t(`${G}.regions.body`, 'Adım içeriği'),
    footer: t(`${G}.regions.footer`, 'Devam / İçe Aktar'),
  },
  navItems: [
    t(`${G}.nav.mapping`, 'Sütun Eşleştirme'),
    t(`${G}.nav.preview`, 'Önizleme'),
    t(`${G}.nav.result`, 'Sonuç'),
  ],
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Dosyayı seçin'),
      text: t(`${G}.s1.text`, '"Dosya Seç" ile .xlsx, .xls veya .csv dosyanızı seçin. İlk satır sütun başlıkları olarak okunur; dosyada birden çok sayfa varsa sağdaki listeden doğru sayfayı seçin. Hazır başlıklı boş bir dosya için "Örnek Şablon İndir" düğmesini kullanın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Barkodlar hücrede sayı olarak kayıtlı olsa da tam haliyle okunur; metin hücrelerdeki baştaki sıfırlar korunur.'),
        t(`${G}.s1.tip2`, 'Dosya adının yanındaki çarpı, seçimi ve eşleştirmeyi sıfırlar.'),
      ],
    },
    {
      region: 'tabs',
      title: t(`${G}.s2.title`, '2. Sütunları eşleştirin'),
      text: t(`${G}.s2.text`, 'Her katalog alanı için dosyanızdaki karşılık gelen sütunu seçin. Başlık adları tanınırsa eşleştirme otomatik yapılır; yine de her alanı kontrol edin. "Ürün Adı" ve "Sektör" zorunludur (yıldızlı); bunlar eşleşmeden "Devam" açılmaz. Altta dosyanın ilk satırları örnek olarak görünür.'),
      tips: [
        t(`${G}.s2.tip1`, 'Fiyat sütunları içe aktarılmaz: katalog referans listesidir, dosyada alış/satış fiyatı olsa bile eşleştirme listesinde yer almaz.'),
        t(`${G}.s2.tip2`, 'Boş bıraktığınız alanlar için varsayılanlar: birim Adet, KDV oranı %20, KDV durumu Kdv Dahil. KDV oranı 0–100 dışındaysa satır atlanır.'),
        t(`${G}.s2.tip3`, 'Bir sütun yalnız bir alana bağlanabilir; otomatik eşleştirmede aynı sütunu ilk alan alır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Önizlemeyi kontrol edin'),
      text: t(`${G}.s3.text`, 'Kartlar eklenecek ürün, barkod çakışması, atlanacak satır ve yeni sektör / kategori sayısını gösterir. Dosyada katalogda olmayan sektör ve kategori adları varsa bunlar içe aktarma sırasında otomatik oluşturulur; liste halinde gösterilir, yazım hatası olup olmadığına bakın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Ürün adı veya sektörü boş satırlar ile dosya içinde aynı barkodu tekrar eden satırlar (ilki kalır) atlanır; tablolarda satır numarasıyla listelenir.'),
        t(`${G}.s3.tip2`, 'Kategori 2, Kategori 1\'in alt kategorisi olarak oluşturulur; ürüne en alttaki kategori yazılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Çakışan barkodlar: Atla veya Güncelle'),
      text: t(`${G}.s4.text`, 'Barkodu katalogda zaten olan satırlar için "Atla" (varsayılan, mevcut ürüne dokunulmaz) ya da "Mevcut kaydı güncelle" seçin.'),
      tips: [
        t(`${G}.s4.tip1`, 'Güncelle, katalogdaki ürünün bilgilerini dosyadaki satırla tamamen değiştirir: dosyada boş olan katalog kodu ve kategori boşalır, birim ve KDV varsayılana döner, ürünün görsel adresi silinir ve pasif ürün yeniden aktif olur.'),
        t(`${G}.s4.tip2`, 'Güncelleme satır satır yapıldığı için çakışma sayısı yüksekse uzun sürebilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. İçe aktarın ve sonucu indirin'),
      text: t(`${G}.s5.text`, '"İçe Aktar" önce sektörleri ve kategorileri hazırlar, sonra ürünleri 500\'lük gruplar halinde kaydeder; ilerleme çubuğu aşamayı gösterir. İşlem sürerken pencere kapatılamaz. Sonuç ekranında eklenen, güncellenen, atlanan ve kaydedilemeyen satır sayıları yazar.'),
      tips: [
        t(`${G}.s5.tip1`, '"Hata Logunu İndir" kaydedilemeyen satırları ve barkod çakışmalarını gerekçesiyle Excel olarak verir.'),
        t(`${G}.s5.tip2`, '"Yeni Dosya" pencereyi kapatmadan baştan başlatır. İçe aktarılan ürünler aktif olarak eklenir ve katalog listesi kapatınca yenilenir.'),
      ],
    },
  ],
});
